<template>
  <div class="list-item" @click="onLink(item)">
    <div class="header">
      <div class="name">{{ item.itemName }}申请单</div>
    </div>
    <div class="content">
      <div class="wrap">No.{{ item.orderNo }}</div>
      <div class="wrap">日期:{{ item.createTime }}</div>
      <!-- sysDes 实在父组件生成好的诊断信息 -->
      <div class="wrap">诊断：{{ item.sysDes }}</div>
      <div class="wrap">项目：{{ item.itemName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    onLink(item) {
      // 选择
      this.$emit('selected', {
        data: item,
        status: 'edit'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  position: relative;

  &::before {
    content: '';
    display: block;
    height: 0.512rem;
  }
  .header {
    display: flex;
    background: #eaf5ff;
    border-radius: 0.085333rem 0.085333rem 0 0;
    overflow: hidden;
    .name {
      position: relative;
      padding-left: 0.512rem;
      padding-right: 0.597333rem;
      flex: 0 0 auto;
      font-size: 0.682667rem;
      line-height: 1.365333rem;
      color: #fff;
      background: #0089ff;
      border-radius: 0.085333rem 0rem 0rem 0rem;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 80%;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        width: 0;
        height: 0;
        border-style: solid;
        border-color: transparent #eaf5ff #eaf5ff transparent;
        border-width: 0.704rem 0.170667rem 0.704rem 0.170667rem;
      }
    }
  }

  .content {
    padding: 0.298667rem 0.533333rem;
    border: 0.042667rem solid #ececec;
    border-radius: 0.085333rem;
    .wrap {
      font-size: 0.64rem;
      line-height: 1.408rem;
      font-weight: 400;
      color: #222;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>
